import { Helmet } from '@dr.pogodin/react-helmet';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';
import Loading from '../common/lib/Loading';
import NoticeSiteHasBeenArchived from '../common/lib/NoticeSiteHasBeenArchived';
import PageNotFound from '../common/lib/PageNotFound';
import XoopsCode from '../common/lib/XoopsCode';
import type { MultiLang } from '../config';
import Functions from '../functions';
import CreditsUtils, { type CreditsIndexData, type CreditsPageDetailData } from './lib/CreditsUtils';

interface Props {
    lang: MultiLang;
    id: number;
}

interface LoadedPage {
    id: number;
    index: CreditsIndexData | null;
    page: CreditsPageDetailData | null;
}

const CreditsPage = (props: Props) => {
    const { lang, id } = props;
    const [loaded, setLoaded] = useState<LoadedPage | null>(null);

    useEffect(() => {
        let active = true;
        Promise.all([CreditsUtils.getIndex(), CreditsUtils.getPage(id)]).then(([index, page]) => {
            if (active) {
                setLoaded({ id, index, page });
            }
        });
        return () => {
            active = false;
        };
    }, [id]);

    if (loaded === null || loaded.id !== id) {
        return <Loading />;
    }
    const { index, page } = loaded;
    if (index === null || page === null) {
        return <PageNotFound lang={lang} />;
    }
    const mtitle = Functions.mlang(index.name, lang);
    const title = Functions.mlang(page.title, lang);
    const lastupdate = page.lastupdate === 0 ? '' : format(new Date(page.lastupdate * 1000), 'MMMM do, yyyy');
    return (
        <>
            <Helmet>
                <title>
                    {title} - {mtitle} - {Functions.siteTitle(lang)}
                </title>
            </Helmet>
            <h3>{title}</h3>
            <NoticeSiteHasBeenArchived lang={lang} />
            {lastupdate !== '' && (
                <div style={{ textAlign: 'right' }}>
                    {Functions.mlang('[en]Last Update[/en][ja]最終更新日[/ja]', lang)} : {lastupdate}
                </div>
            )}
            <hr />
            <XoopsCode lang={lang} text={page.content} dohtml={true} />
        </>
    );
};

export default CreditsPage;
